import validate from "/tmp/build_163e7334/node_modules/nuxt/dist/pages/runtime/validate.js";
import authenticated_45global from "/tmp/build_163e7334/middleware/authenticated.global.ts";
import manifest_45route_45rule from "/tmp/build_163e7334/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  authenticated_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "home-redirect": () => import("/tmp/build_163e7334/middleware/homeRedirect.ts"),
  "service-requests-gate": () => import("/tmp/build_163e7334/middleware/serviceRequestsGate.ts")
}